<template>
  <b-table-simple class="bg-white" small striped borderless>
    <b-tbody>
      <b-tr v-if="!accepted">
        <b-td class="font-weight-bold">
          {{ $t('Date') }}
        </b-td>
        <b-td>
          {{ lead.dateReleased | parseDateTimeNs }}
        </b-td>
      </b-tr>
      <b-tr v-if="!accepted">
        <b-td class="font-weight-bold">
          {{ $t('Leads Sold') }}
        </b-td><b-td>
          {{ lead[0].sold }}/{{ lead[0].number_leads_requested }} {{ leadsSold(lead[0].sold, lead[0].number_leads_requested) }}
        </b-td>
      </b-tr>
      <b-tr v-for="(question, index) in filtered" :key="index">
        <b-td class="font-weight-bold">
          {{ question.question }}
        </b-td>
        <b-td>
          {{ question.answer }}
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import LeadsSoldMixin from "@/imports/mixins/leadsSold";

export default {
  name: "EnquiryQuestions",
  mixins: [LeadsSoldMixin],
  props: {
    questions: {
      type: Array,
      default: () => []
    },
    lead: {
      type: Object,
      default: () => {}
    },
    accepted: {
      type: Boolean,
      default: true,
    }
  },
  data: function() {
    return {
      hidden: [
        "Description of proposed work",
        "Qualified",
      ],
    }
  },
  computed: {
    filtered: function() {
      return this.questions.filter((question) => !this.hidden.includes(question.question));
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  @include font-size($font-size-13);
}
</style>
